export function required(value: string | number) {
    return value === undefined || value === null ||  String(value).length === 0 ? 'Required field' : false;
}

export function email(value: string) {
    return !(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i).test(value) ? 'Invalid email address' : false;
}

export function name(value: string) {
    return !(/^([a-åA-Å\u00F0-\u02AF]+\s?)+$/i).test(value) ? 'Invalid name' : false;
}

export function mobile(value: string) {
    return !(/^\+\(?\d{2,4}\)?[\d]{4,}$/i).test(value) ? 'Format: +4588822888' : false;
}

export function between(min: number, max: number) {
    return function (value: string) {
        if (value.length < min) {
            return `Minimum ${min} characters`;
        }
        if (value.length > max) {
            return `Maximum ${max} characters`;
        }
        return false;
    };
}

export function slug(value: string) {
    return !(/^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/i).test(value) ? 'Must only contain A-Z, numbers and dashes' : false;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utilities/validation.ts